import React from 'react';
import {
    Avatar, Button, ButtonGroup, Cell, Chip,
    Div, FormItem, Headline, IconButton, Input, List, NativeSelect,
    PanelHeader, SplitCol, SplitLayout, Textarea, Title
} from '@vkontakte/vkui';
import {AdaptivityContext, formatQnt, getGUID, setQuizStep} from "../assets/constants";
import Fancybox from "../assets/fancybox";
import moment from "moment";
import * as constants from "../assets/constants";
import {
    Icon16Clear,
    Icon24Story, Icon20ListPlusOutline, Icon16ArrowshapeRightOutline
} from "@vkontakte/icons";
import KBInput from "../assets/KBInput";
import CopyToClipBoard from "../assets/CopyToClipboardButton";
import HelpButton from "../assets/HelpButton";
import Autocomplete from "../assets/autocomplete";

class DocQntInput extends React.Component {
    state = {
        series: [],
        current_qnt: '',
        current_qnt_error: ''
    }

    constructor(props) {
        super(props);
        this.GUID = getGUID()
        this.state.current_qnt = this.props.product.realQnt
        this.state.series = this.props.product.series ?? []
    }


    componentDidMount() {
        window.addEventListener('message', this.receiveMessage, false)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage)
    }

    receiveMessage = (event) => {
        if (event.data == 'incomingGoGetBack') {
            setQuizStep(3, 'Incoming')
        }
    }

    render() {
        const images_url = this.props.base_url.replace("frontend/", '')

        const product_series = []

        if (this.props.product.product_series) {
            this.props.product.product_series.map(el => {
                    if (!el.code) return
                    product_series.push({
                        label: el.code,
                        id: el.external_id
                    })
                }
            )
        }
        return (
            <SplitLayout>
                <SplitCol>
                    <PanelHeader fixed={true}>
                        <Div>
                            Приемка. Ввод количества
                        </Div>
                    </PanelHeader>
                    <SplitLayout>
                        <SplitCol>
                            <Fancybox key={'IncomingDefectiveProductFancyBox'}>

                                <Div className="incoming-products-row" key={"incomingDefectiveProductRow1"}>
                                    <a data-fancybox={'gallery' + this.props.product.product_id}
                                       href={images_url + this.props.product.img.replace('https:/l', 'https://l').replace('https:/lab', 'https://lab').replace(images_url, '')}>
                                        {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                 size={AdaptivityContext.isMobile ? 40 : 140}
                                                 src={images_url + 'image/200/200/' + this.props.product.img.replace('https:/l', 'https://l').replace('https:/lab', 'https://lab').replace(images_url, '')}
                                        />}
                                    </a>
                                    <div className="incoming-products-row_name">{this.props.product.name}</div>
                                    <div
                                        className="incoming-products-row_qnt-need">{formatQnt(this.props.product.quantity * 1, true)}
                                        <span
                                            className="incoming-products-row_qnt-need_unit">{this.props.product.unit.title}</span>
                                    </div>

                                    <div className="incoming-products-row_qnt">
                                        <KBInput readonly={this.state.series.length > 0 || product_series.length > 0}
                                                 value={this.state.current_qnt}

                                                 readonlyError={() => product_series.length > 0 && window.postMessage({
                                                     timeout: 4000,
                                                     type: 'error',
                                                     text: 'У товара есть серии, необходимо заполнить количество через список серий!'
                                                 })}

                                                 onChange={this.setQnt}/>
                                    </div>
                                </Div>
                                {this.state.current_qnt_error &&
                                    <Div>
                                        <Headline style={{color: 'red'}}>{this.state.current_qnt_error}</Headline>
                                    </Div>}
                            </Fancybox>
                        </SplitCol>
                    </SplitLayout>
                    <SplitLayout>
                        <SplitCol>
                            <Div>
                                <Title style={{display: 'flex', justifyContent: 'space-between'}}>
                                    Серии <Button mode="secondary"
                                                  onClick={() => this.addSeria()}
                                                  style={{width: "100px"}}><Icon20ListPlusOutline
                                    height={20}/></Button>
                                </Title>
                            </Div>
                            <div className='incoming-products-wrapper'>
                                {this.state.series ? this.state.series.map((series_item, index) => (
                                    <div style={{borderBottom: '#dadada 1px solid'}}
                                         className="incoming-products-row series">
                                        <div style={{width: '70%'}}>
                                            <FormItem bottom={series_item.code_error}
                                                      status={series_item.code_error ? 'error' : ''}>
                                                <Autocomplete value={series_item.code} items={product_series}
                                                              onChange={label => this.setSeriesCode(label, index)}/>
                                            </FormItem>
                                        </div>
                                        <div style={{width: '20%'}}>
                                            <FormItem>
                                                <KBInput value={series_item.qnt}
                                                         onChange={(value) => this.setSeriesQnt(value, index)}/>
                                            </FormItem>

                                        </div>
                                        <div>
                                            <Div>
                                                <IconButton mode="primary" mode="secondary"
                                                            onClick={() => this.removeSeria(index)}>
                                                    <Icon16Clear/>
                                                </IconButton>
                                            </Div>

                                        </div>
                                    </div>)) : ''}
                            </div>
                        </SplitCol>
                    </SplitLayout>
                    <SplitLayout>
                        <SplitCol>
                            <Div className="action-board">
                                <ButtonGroup mode="horizontal" stretched>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => setQuizStep(3, 'Incoming')}>Отмена</Button>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => this.saveQnt()}>Сохранить</Button>
                                </ButtonGroup>
                            </Div>
                        </SplitCol>
                    </SplitLayout>
                </SplitCol>
            </SplitLayout>)
    }

    addSeria = () => {
        const old = this.state.series

        old.push({code: '', qnt: ''})
        this.setState({series: old})
        this.getTotal(old)
    }
    getTotal = (olds) => {
        const total_ = olds.reduce((total, item) => total + item.qnt * 1, 0)
        this.setQnt(total_)
    }
    setQnt = (value) => {

        this.setState({current_qnt: value})
    }

    setSeriesQnt = (value, index) => {
        const olds = this.state.series

        const old = olds[index]
        old.qnt = value
        olds[index] = old
        this.setState({series: olds})

        this.getTotal(olds)
    }
    setSeriesCode = (value, index) => {

        console.log(value)

        const olds = this.state.series

        const old = olds[index]
        old.code = value
        olds[index] = old
        this.setState({series: olds})

        this.getTotal(olds)
    }

    removeSeria = (index) => {
        const olds = this.state.series

        olds.splice(index, 1)
        this.setState({series: olds})

        this.getTotal(olds)
    }

    saveQnt = () => {
        let errors = '';

        this.setState({current_qnt_error: ''})


        if (1 * this.state.current_qnt == 0) {
            errors++
            this.setState({current_qnt_error: 'Необходимо указать количество'})
        }
        const olds = this.state.series
        olds.map((series_item, index) => {
            series_item.code_error = ''
            series_item.qnt_error = ''

            if (series_item.code.trim() == '') {
                errors++
                series_item.code_error = 'Необходимо указать номер серии!'
            }
            if (series_item.qnt * 1 == 0) {
                errors++
                series_item.code_error += '\r\n Необходимо указать количество'
            }
        })
        this.setState({series: olds})
        if (errors == 0) {
            window.postMessage({type: "saveIncomingQnt", qnt: this.state.current_qnt, series: this.state.series})
        } else {
            window.postMessage({type: "error", text: "Нужно заполнить все поля корректно"})
        }
    }
}

export default DocQntInput